import {RequiredLanguageProfile} from '../../../../../types/shared-types';

type DepartmentName = string | RequiredLanguageProfile | Partial<RequiredLanguageProfile>;

export const getWorkforceDepartmentDisplayName = (
  name: DepartmentName | undefined,
  currentLanguage: 'en' | 'de'
): string => {
  if (!name) {
    return '';
  }

  if (typeof name === 'string') {
    return name;
  }

  return name[currentLanguage] ?? name.en ?? name.de ?? '';
};
